import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useEditMode } from '../../../shared/hooks/useEditMode';
import ProjectEditControllerFixed from './ProjectEditControllerFixed';
import { StyledImgDivContainerProps } from '../../../shared/dto/StyleCompRepository';
import { convertS3UrlToCloudFrontUrl } from '../../../shared/aws/awsHelper';
import OptimizedMoleculeImgDivContainer from '../../../shared/component/molecule/OptimizedMoleculeImgDivContainer';
import { ProjectSimpleData } from '../../../shared/dto/EntityRepository';
import { usePageOwnerIdentityStore } from '../../../shared/store/pageOwnerIdentityStore';


interface ProjectSimpleTicketProps {
  data: ProjectSimpleData;
}

const ProjectSimpleTicket: React.FC<ProjectSimpleTicketProps> = ({ data }) => {
  const pageOwner = usePageOwnerIdentityStore(s => s.pageOwner);
  const { isEditMode } = useEditMode();
  const isPublic = data.isPublic;
  const projectDetailPath = pageOwner ? `/@${pageOwner.handle}/projects/${data.id}` : '#';

  const handleProjectLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isEditMode || !pageOwner) {
      e.preventDefault();
    }
  }

  return (
    <ProjectSimpleComp>
      <ContentWrapper to={projectDetailPath} onClick={handleProjectLinkClick} $isPublic={data.isPublic}>
        <OptimizedMoleculeImgDivContainer
          backgroundImg={convertS3UrlToCloudFrontUrl(data.originUrl)}
          StyledImgDivContainer={ProjectRepresent}
          $focusX={data.focusX ?? 0.5}
          $focusY={data.focusY ?? 0.5}
        />
        <ProjectSimpleInfo>
          <ProjectSimpleTitle>{data.title}<ProjectSimpleYear>{data.projectYear ? data.projectYear : ''}</ProjectSimpleYear></ProjectSimpleTitle>
          {(isEditMode || !isPublic) &&
            <Indicator>
              {isPublic ? ":Public" : ":Private"}
            </Indicator>
          }
        </ProjectSimpleInfo>
      </ContentWrapper>
      <ProjectEditControllerFixed
        projectId={data.id}
        isPublic={data.isPublic}
      />
    </ProjectSimpleComp>
  );
};

const ProjectSimpleComp = styled.div`
  position: relative;

  width: 100%;
  height: clamp(100px, 20vh, 200px);
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end; 
  margin-bottom: 4px;
`;

const ContentWrapper = styled(Link)<{ $isPublic: boolean }>`
  display: flex;
  flex-direction: column;
  width: fit-content;
  height: 100%;
  color: inherit;
  text-decoration: none;
  ${({ $isPublic }) => !$isPublic && `
    opacity: 0.6;
  `}
  cursor: pointer;
`;

const ProjectSimpleInfo = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2px;
`;

const ProjectSimpleYear = styled.span`
  margin-left: 4px;
  color: ${({ theme }) => theme.colors.color_Gray_05};
  ${({ theme }) => theme.typography.Footer_02};
`;

const ProjectSimpleTitle = styled.h2`
  text-align: end;
  ${({ theme }) => theme.typography.Body_02_1};
`;

const Indicator = styled.div`
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_05};
`;

const ProjectRepresent = styled.div<StyledImgDivContainerProps & {
  $focusX: number;
  $focusY: number;
}>`
  width: clamp(600px, calc(40vw), 700px);
  height: 100%;

  background-image: url(${props => props.$backgroundImg});
  background-size: cover;
  background-position: ${({ $focusX, $focusY }) => `${$focusX * 100}% ${$focusY * 100}%`};
  position: relative;
`;




export default ProjectSimpleTicket;
